import { useTranslation } from 'react-i18next';
import { PageBarHead } from '../../../../PageBar/PageBar';
import { scrollTop } from '../../../../../utils/utilities';

// The app bar's back pill, rendered in place at the top of the card. A step change, not a route
// change, so it scrolls up itself rather than through PageBar's back.
const BackButton = ({ handler }) => {
  const { t } = useTranslation();

  const handleBack = () => {
    handler();
    scrollTop(undefined, false);
  };

  return <PageBarHead back={{ label: t('common.back') }} onBack={handleBack} />;
};

export default BackButton;
